import { render } from "./LogisticsList.vue?vue&type=template&id=5bea886e&scoped=true"
import script from "./LogisticsList.vue?vue&type=script&lang=js"
export * from "./LogisticsList.vue?vue&type=script&lang=js"

import "./LogisticsList.vue?vue&type=style&index=0&id=5bea886e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bea886e"]])

export default __exports__